import React from 'react';

/**
 * Standard empty state — turns dead ends into next steps.
 *
 * <EmptyState
 *   icon={<Package className="h-12 w-12" />}
 *   title="No orders yet"
 *   description="Parts you order will appear here."
 *   action={<Button onClick={() => history.push('/user/part-enquiry')}>Browse parts</Button>}
 * />
 */
function EmptyState({ icon, title, description, action, className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-12 px-6 ${className}`}>
      {icon && <div className="text-gray-400 mb-4" aria-hidden="true">{icon}</div>}
      <h3 className="text-base font-semibold text-gray-900">{title}</h3>
      {description && <p className="mt-1 text-sm text-gray-500 max-w-sm">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export default EmptyState;
